import { Link } from 'react-router-dom';
import { postListFetcher } from '@/shared/api/list';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';

interface PromoLog extends ListRow {
  id: number;
  operator_id?: { id: number; name?: string };
  create_time?: number;
  old_data?: string | number;
  new_data?: string | number;
}

const operatorLink = (log: PromoLog, label: string | number | undefined) => (
  <Link to={`/users/user/${log.operator_id?.id}`}>{label}</Link>
);

const config: ListPageConfig<PromoLog> = {
  queryKey: 'marketing-promo-logs',
  title: 'Логи условий промоакций',
  errorText: 'Ошибка загрузки логов',
  fetchList: postListFetcher('/billing/billing-promo-log/list/'),
  rows: ['promotion_logs'],
  filters: [
    { name: 'create_time_from', label: 'Начиная с даты', kind: 'datetime' },
    { name: 'create_time_to', label: 'Заканчивая датой', kind: 'datetime' },
  ],
  columns: [
    { header: 'ID', render: (log) => log.id },
    { header: 'ID оператора', render: (log) => operatorLink(log, log.operator_id?.id) },
    { header: 'Имя оператора', render: (log) => operatorLink(log, log.operator_id?.name) },
    { header: 'Дата и время', render: (log) => formatUnixDateTime(log.create_time) },
    { header: 'Старый процент', render: (log) => log.old_data },
    { header: 'Новый процент', render: (log) => log.new_data },
  ],
};

export const PromoLogsPage = () => <GenericListPage config={config} />;
